import { OnInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { DashboardService } from 'src/app/core/services/dashboard/dashboard.service';
import { UserService } from 'src/app/core/user/user.service';

@Component({
  selector: 'app-modal-delegation',
  templateUrl: './modal-delegation.component.html',
  styleUrls: ['./modal-delegation.component.scss'],
})
export class ModalDelegationComponent implements OnInit {
  @Input() bien: any;
  @Output() saveOrUpdate = new EventEmitter<any>();

  user: any;
  isChecked: boolean = false;
  userInformation: any = {
    name: '',
    lastname: '',
    email: '',
    phone: '',
    adresses: {
      codePostal: null,
      ville: null,
      adresse: null,
    },
    proCard: '',
    etudeNotariale: '',
  };
  honoraires: any;
  constructor(
    private modalService: NgbModal,
    private router: Router,
    private _userService: UserService,
    private _dashboardService: DashboardService,
    private _cookie: CookieService
  ) {}

  ngOnInit() {
    this.user = this._userService.getUser();
    if (this.user) {
      this.userInformation['name'] = this.user['nom'];
      this.userInformation['lastname'] = this.user['prenom'];
      this.userInformation['email'] = this.user.usermail;
      this.userInformation['phone'] = this.user.phone;
      this.userInformation['adresses'] = this.user.adresses
        ? this.user.adresses
        : this.userInformation['adresses'];
      this.userInformation['proCard'] = this.user['proCard']
        ? this.user['proCard']
        : null;
      this.userInformation['etudeNotariale'] = this.user['etudeNotariale']
        ? this.user['etudeNotariale']
        : null;
    }
    if (this.bien) {
      if (this.bien.honorairesMandat != null) {
        this.honoraires = this.bien.honorairesMandat;
      } else {
        this.honoraires = 0;
      }
      this.honoraires += this.bien.honorairesMandatAcquereur;
    }
  }

  agreedMandate(id: number, userInformation: any, isInvalid: any) {
    userInformation['partner'] = this.user['id'];
    if (!isInvalid) {
      this._dashboardService
        .agreeMandate(id, userInformation)
        .subscribe((response: any) => {
          if (response['data']) {
            let userMandateProperty = this.user['mandatedProperties'];
            if (userMandateProperty.indexOf(id) === -1) {
              userMandateProperty.push(id);
            }
            this.user['mandatedProperties'] = userMandateProperty;
            this.user['phone'] = userInformation['phone'];
            this.user['telephone'] = userInformation['phone'];
            // edit property user
            this.user['adresses'] = userInformation['adresses'];
            this._cookie.set('user', JSON.stringify(this.user));
            setTimeout(() => {
              this.modalService.dismissAll();
              this.saveOrUpdate.emit();
            }, 0);
          }
        });
    }
  }

  openVertically(content: any) {
    this.modalService.open(content, { size: 'xl' });
  }
}
